export const CHATS_CHANNEL = 'chats_channel';

export function getBroadcastChannel(): BroadcastChannel | undefined {
  if (typeof BroadcastChannel === 'undefined') {
    return;
  }

  return new BroadcastChannel(CHATS_CHANNEL);
}
